import React, { JSX, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isAdminFromToken } from "../utils/jwt";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("authToken");
      
      // Token yoksa login sayfasına yönlendir
      if (!token) {
        navigate("/login");
        return;
      }

      // Token'dan admin yetkisini kontrol et
      const isAdmin = isAdminFromToken(token);
      
      if (!isAdmin) {
        // Admin değilse token'ı temizle ve login'e yönlendir
        localStorage.removeItem("authToken");
        alert("Bu panele sadece admin kullanıcılar erişebilir.");
        navigate("/login");
        return;
      }

      setIsChecking(false);
    };

    checkAuth();
  }, [navigate]);

  // Auth kontrolü devam ederken loading göster
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Yetki kontrol ediliyor...
      </div>
    );
  }

  return children;
}
